var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 19,
    viewBox: "0 0 115 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xC3\x8E\xC3\x93\xC3\x88_1",
    clipPath: "url(#clip0_5234_4103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1452 4.85871L11.7066 11.2778L5.26795 4.85871V0.000488281H0V7.04393L11.7066 18.7505L23.4131 7.04393V0.000488281H18.1452V4.85871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.4619 11.7266V18.7505H26.7494V13.8923L33.1685 7.47317L39.6071 13.8923V18.7505H44.8945V11.7266L33.1685 0.000488281L21.4619 11.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.9938 0.193848V13.2467H71.1361V0.193848H65.8486V15.9001C65.8486 16.2477 65.9174 16.5918 66.051 16.9126C66.1846 17.2335 66.3803 17.5247 66.627 17.7696C66.8736 18.0144 67.1663 18.208 67.4881 18.3392C67.81 18.4705 68.1546 18.5367 68.5021 18.5341H86.6278C86.9753 18.5367 87.3199 18.4705 87.6417 18.3392C87.9636 18.208 88.2562 18.0144 88.5029 17.7696C88.7496 17.5247 88.9453 17.2335 89.0789 16.9126C89.2125 16.5918 89.2813 16.2477 89.2812 15.9001V0.193848H83.9938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.6696 5.48131H63.7422V0.193848H40.3096V5.48131H49.3821V18.5341H54.6696V5.48131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M114.334 9.24755C114.324 8.55211 114.043 7.88799 113.552 7.3962C113.06 6.9044 112.396 6.62365 111.7 6.61357H97.9256V11.901H109.066V13.2668H96.6964C96.6964 12.7205 96.6964 15.0618 96.6964 10.7499V7.10135V5.38439H114.412V0.116434H94.0234C93.6791 0.111884 93.3375 0.176941 93.0189 0.307699C92.7004 0.438457 92.4116 0.632221 92.1699 0.87736C91.9109 1.13018 91.7077 1.43436 91.5733 1.77037C91.4389 2.10639 91.3763 2.4668 91.3894 2.82845V15.9203C91.3995 16.6157 91.6802 17.2798 92.172 17.7716C92.6638 18.2634 93.3279 18.5442 94.0234 18.5543H114.334V9.24755Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5234_4103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.393,
    height: 18.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.da696e91c82a126e97178b97dc9fc29e.svg";
export { ForwardRef as ReactComponent };